var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel granary-panel" }, [
    _c("div", { staticClass: "content" }, [
      _c(
        "div",
        { staticClass: "top-box" },
        [
          _vm._l(_vm.list, function (item, i) {
            return _c(
              "div",
              {
                key: item.name,
                class:
                  _vm.activeIndex == i ? "top-item active-item" : "top-item",
              },
              [
                _c("div", { staticClass: "item-left" }, [
                  _c("img", {
                    staticClass: "item-icon",
                    attrs: { src: item.iconPath },
                  }),
                ]),
                _c("div", { staticClass: "item-right" }, [
                  _c("div", { staticClass: "right-name" }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                  _c("div", { staticClass: "right-bot" }, [
                    _c("span", { staticClass: "item-num" }, [
                      _vm._v(_vm._s(item.total)),
                    ]),
                    _c("span", { staticClass: "item-unit" }, [
                      _vm._v("(" + _vm._s(item.unit) + ")"),
                    ]),
                  ]),
                  _c("img", {
                    staticClass: "title-img",
                    attrs: {
                      src: require("images/granary/nc/hjzzjz-title-bg.png"),
                    },
                  }),
                ]),
              ]
            )
          }),
          _c("div", { staticClass: "area-title" }, [
            _vm._v(" “茂南、电白、信宜、高州、化州”行政村数排行 "),
          ]),
          _vm._l(_vm.rankingList, function (it, index) {
            return _c("div", { key: index, staticClass: "ranking-item flex" }, [
              _c("div", { staticClass: "ranking-left" }, [
                _c("img", { attrs: { src: it.iconPath } }),
              ]),
              _c(
                "div",
                { staticClass: "ranking-right" },
                [
                  _c("div", { staticClass: "ranking-right-top flex" }, [
                    _c("div", { staticClass: "city-name" }, [
                      _vm._v(_vm._s(it.city)),
                    ]),
                    _c("div", { staticClass: "num-box" }, [
                      _c("span", { staticClass: "total-num" }, [
                        _vm._v(_vm._s(it.totalNum)),
                      ]),
                      _c("span", { staticClass: "ranking-unit" }, [
                        _vm._v("（个）"),
                      ]),
                    ]),
                  ]),
                  _c("el-progress", {
                    attrs: {
                      percentage: _vm.handleProgressData(it.totalNum),
                      "show-text": false,
                    },
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }